import { jsx as _jsx } from "react/jsx-runtime";
import { BUCKET_FILTER } from '@as-react/common-types';
import { FiltersSelectList } from './FiltersSelectList';
export const FilterItemContentBucketFilter = ({ desktop, filter, onFilterItemChange }) => (_jsx(FiltersSelectList, { desktop: desktop, filter: filter, onFilterItemChange: onFilterItemChange, type: BUCKET_FILTER }));
